module.exports = __webpack_public_path__ + "static/media/PromoImage_Coins.5aa0755b.png";